import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { notify } from '../services/notification';
import { HTTP_STATUS } from '../constants/httpsStatus/httpsStatus'
import { paginationCount } from '../constants/paginationCount/paginationCount'
import { pgmThreeWheelerConstant } from '../constants/constant'


export const pgmlistAction = (page, parm, value, criteria, fromDate, toDate) => (dispatch) => {
  let baseUrl = `${process.env.REACT_APP_API_URL}${Url.PGM_LIST}/${parm}`;
  let queryParams = new URLSearchParams();

  queryParams.append("page", page);
  queryParams.append("page_size", 10);

  if (value && criteria) {
    queryParams.append(criteria, value);
  }

  if (fromDate) {
    queryParams.append("created_from", fromDate);
  }

  if (toDate) {
    queryParams.append("created_to", toDate);
  }

  const fullUrl = `${baseUrl}?${queryParams.toString()}`;

  let options = {
    method: "GET",
    headers: getHeaders(),
    url: fullUrl,
  };

  return axios(options)
    .then((resp) => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.GET_PGM_LIST, payload: resp });
        return resp;
      } else {
        return null;
      }
    })
    .catch((error) => {
      errorHandler(error);
    });
};

export const pgmlist3wAction = (queryStr) => dispatch => {
  let url = `${process.env.REACT_APP_API_URL}${Url.PGM_LIST}/Approved?${queryStr}`;
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp?.status === HTTP_STATUS.SUCCESS) {

      dispatch({ type: types.GET_PGM_LIST, payload: resp })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

export const pgmRetailerListAction = (page, param, value, criteria, fromDate, toDate, isRetailerLinked) => dispatch => {
  let url = process.env.REACT_APP_API_URL + Url.PGM_LIST + "/All";
  let queryParams = `?user_type=retailer&page=${page}&page_size=10`;

  if (isRetailerLinked) {
    queryParams += `&is_retailer_linked=${isRetailerLinked}`;
  }

  if (param !== "all" && value) {
  queryParams += `&${criteria}=${value}`;
  }
if (fromDate) {
    queryParams += `&created_from=${fromDate}`;
  }
  if (toDate) {
    queryParams += `&created_to=${toDate}`;
  }
  url += queryParams;
  let options = {
    method: 'GET',
    headers: getHeaders(),
    url: url
  };
  return axios(options)
    .then(resp => {
      if (resp?.status === HTTP_STATUS.SUCCESS) {
        dispatch({ type: types.GET_RETAILER_LIST, payload: resp });
        return resp;
      } else {
        return null;
      }
    })
    .catch(error => {
      errorHandler(error);
    });
};

// Pgae number
export const pgmpageAction = (params = {}) => dispatch => {
  dispatch({ type: types.PGM_PAGE, payload: params })
}
// category data
export const categoryAction = (params = {}) => dispatch => {
  dispatch({ type: types.PGM_CATEGORY, payload: params })
}
// Searched data
export const searchCriteriaAction = (params = {}) => dispatch => {
  dispatch({ type: types.SEARCH_CRITERIA, payload: params ? { data: params } : null })
}
export const retailersearchCriteriaAction = (params = {}) => dispatch => {
  dispatch({ type: types.RETAILER_SEARCH_CRITERIA, payload: params ? { data: params } : null })
}
//pgm Detail   
export const pgmdetailAction = (parms) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.PGM_DETAIL + "/" + parms
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp?.status ===HTTP_STATUS.SUCCESS) {
      dispatch({ type: types.GET_PGM_DETAIL, payload: resp })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

//Admin verification

export const putadminverifyAction = (params = {}) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.PGM_APPROVAL
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp?.status ===HTTP_STATUS.SUCCESS) {
      dispatch({ type: types.PUT_ADMIN_VERIFICATION_UPDATE, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)
  })
}
export const UpdatePgmDetailAction = (params = {}) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.PGM_DETAIL_EDIT;
  const options = {
    method: 'POST',
    url: url,
    headers: getHeaders(),
    data: params
  };

  return axios(options)
    .then(resp => {
      if (resp?.status ===HTTP_STATUS.SUCCESS) {
        dispatch({ type: types.PGM_DETAIL_UPDATE, payload: resp?.data });
        return resp.data;
      } else {
        return null;
      }
    })
    .catch(error => {
      const errorMessage = error?.response?.data?.message || error?.response?.data?.error || "An error occurred";
      notify.error(errorMessage.replace(/[~`!@#$%^&*(){}\[\]"'\/\\]/g, ''));
    });
};
export const pgmlistFilterAction = (parm) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.PGM_LIST + "/" + parm
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp?.status ===HTTP_STATUS.SUCCESS) {

      dispatch({ type: types.GET_PGM_LIST, payload: resp })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

export const toggleUserStatusAction = (id, payload) => (dispatch) => {
  const url = `${process.env.REACT_APP_API_URL}${Url.TOGGLE_USER_STATUS}/${id}`;
  
  const options = {
    method: "PATCH",
    headers: getHeaders(),
    url: url,
    data: payload
  };

  return axios(options)
    .then((resp) => {
      if (resp?.status ===HTTP_STATUS.SUCCESS) {
        dispatch({ type: types.UPDATE_USER_STATUS_SUCCESS, payload: resp?.data });
        return resp;
      } else {
        return null;
      }
    })
    .catch((error) => {
      
      errorHandler(error);
    });
};

